/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TargetChangeAnswerDto = {
    action: TargetChangeAnswerDto.action;
    doIt: boolean;
};

export namespace TargetChangeAnswerDto {

    export enum action {
        GAMES = 'games',
        SLEEP = 'sleep',
        STEPS = 'steps',
        SOCIAL_INTERACTION = 'socialInteraction',
        STRESS = 'stress',
        DIET = 'diet',
    }


}

